import { environment } from '@/environment';

export const COOKIE_KEYS = {
  GOOGLE_AUTH_UUID: 'google_auth_uuid',
  SHOW_NEW_SITE_ONBOARDING: 'show_new_site_onboarding_modal',
  SHOW_ONBOARDING_MODAL: 'show_onboarding_modal',
  MP_EXPERIMENTS: 'mp_experiments',
  FIRST_APP_OPEN: 'first_app_open',
  MP_IDENTITY: 'mp_bs_id',
  ONBOARDING_STEP: 'onboarding_step',

  // GA
  GA_IDENTIFIERS: 'gtmIdnts', // After visiting the site - from gtm
  GA_SERVER_PREVIEW: 'xGtmServerPreview',
};
export interface IGtmIdentifiers {
  ga_fpid: string;
  ga_session_id: string;
}

/** Root domain for cookies shared between extension and web app, per environment */
export const COOKIE_DOMAIN: string = environment.cookieDomain;
